/*
* @Author: tengmaoqing
* @Date:   2018-04-17 15:26:35
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-05-07 14:55:28
*/

import { getProductParams } from '@/apis/base';

export default {
  namespaced: true,
  state: () => ({
    params: {},
    // bList: [],
    // fList: [],
    // fmtBList: [],
    // fmtFList: [],
    // priceInfo: null,
    // queryInfo: null,
    disabeldItems: {
      '82': 'icloud 未解锁不回收'
    },
    currentOption: 0,
    currentPics: {
      popShow: false,
      popReference: null,
      picture: [],
      desc: ''
    }
  }),
  mutations: {
    set (state, params) {
      state.params = params;
    },
    setCurrentOption (state, index) {
      state.currentOption = index;
    },
    setCurrentPics (state, pics) {
      state.currentPics = pics;
    }
  },
  getters: {
    // 最小选项长度
    // minLen (state, getters) {
    //   return state.fmtBList.filter(item => item.oid && item.oname).length;
    // },
    // // 除了考虑还可能考虑其他
    // canSubmit (state, getters) {
    //   return getters.minLen === state.fmtBList.length && true;
    // }
  },
  actions: {
    async get ({ commit }, productId) {
      try {
        let res = await getProductParams(productId);

        if (parseInt(res._errCode) === 0) {
          commit('set', JSON.parse(JSON.stringify(res._data)));
        }
      } catch (e) {
        // console.log('getProductParams_err', e);
      }
    }
  }
};
